module.exports = __webpack_public_path__ + "static/media/bg_top.3604de75.png";